// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"5c88c0f3","236":"c698af7f","323":"b72c27e7","694":"e4d3b050","788":"1a59f3f3","882":"3c9e38b6","886":"4c61d83b"}[chunkId] + ".chunk.css";
};